import * as o from "react";
import r from "../lib/IconBase.es.js";
import t from "../defs/LinkedinLogo.es.js";
const e = o.forwardRef((n, i) => /* @__PURE__ */ o.createElement(r, { ref: i, ...n, weights: t }));
e.displayName = "LinkedinLogoIcon";
const c = e;
export {
  c as LinkedinLogo,
  e as LinkedinLogoIcon
};
